import React from 'react';

const Achievement = ({achievement}) => {
    return (
        <div className='achievements_card'>
            <img src={achievement.url} alt="" className="achievements_card-image" />
            <h3 className="achievements_card-title">{achievement.title}</h3>
            <p className="achievements_card-text">{achievement.text}</p>
        </div>
    );
}

export default Achievement;
